module.exports = __webpack_public_path__ + "img/xlsx.83bc924d.png";